import React from 'react';
import { Field } from 'formik';
import { Row, Col, Label, FormGroup, Button, Input } from 'reactstrap';
import * as dataSeed from '../shared/DataSeed';

export const Page6Summary = ({ errors, touched, values, state, props, occupations, onOccupatioChange, reloadCaptcha }) => (
    <React.Fragment>
        <FormGroup tag="fieldset">
            <legend>Ringkasan Data</legend>
        </FormGroup>
        <table className="table table-striped table-sm">
            <tbody>
                <tr className="d-flex">
                    <td className="font-weight-bold col-3">Nama Depan</td>
                    <td className="col-3">: {values.FirstName}</td>
                    <td className="font-weight-bold col-3">Nama Tengah</td>
                    <td className="col-3">: {values.MiddleName}</td>
                </tr>
                <tr className="d-flex">
                    <td className="font-weight-bold col-3">Nama Belakang</td>
                    <td className="col-3">: {values.LastName}</td>
                    <td className="font-weight-bold col-3">Warga Negara</td>
                    <td className="col-3">: {values.Nationality !== '' && dataSeed.countries.find(el => el.id.toString() == values.Nationality).name}</td>
                </tr>
                <tr className="d-flex">
                    <td className="font-weight-bold col-3">Nomor KTP</td>
                    <td className="col-3">: {values.KTPNumber}</td>
                    <td className="font-weight-bold col-3">Tgl. Kadaluarsa KTP</td>
                    <td className="col-3">: {values.KTPExpiredDate}</td>
                </tr>
                <tr className="d-flex">
                    <td className="font-weight-bold col-3">Tempat Lahir</td>
                    <td className="col-3">: {values.BirthPlace}</td>
                    <td className="font-weight-bold col-3">Tgl. Lahir</td>
                    <td className="col-3">: {values.BirthDate}</td>
                </tr>
                <tr className="d-flex">
                    <td className="font-weight-bold col-3">Jenis Kelamin</td>
                    <td className="col-3">: {values.GenderId !== '' && dataSeed.genders.find(el => el.id.toString() == values.GenderId).name}</td>
                    <td className="font-weight-bold col-3">Agama</td>
                    <td className="col-3">: {values.Religion !== '' && dataSeed.religions.find(el => el.id.toString() == values.Religion).name}</td>
                </tr>
                <tr className="d-flex">
                    <td className="font-weight-bold col-3">NPWP</td>
                    <td className="col-3">: {values.NPWP !== '' && dataSeed.nPWPs.find(el => el.id.toString() == values.NPWP).name}</td>
                    <td className="font-weight-bold col-3">No. NPWP</td>
                    <td className="col-3">: {values.NPWPNumber}</td>
                </tr>
                <tr className="d-flex">
                    <td className="font-weight-bold col-3">Tgl Registrasi</td>
                    <td className="col-3">: {values.NPWPRegistrationDate}</td>
                    <td className="font-weight-bold col-3"></td>
                    <td className="col-3"></td>
                </tr>
                <tr className="d-flex">
                    <td className="font-weight-bold col-3">Status Pernikahan</td>
                    <td className="col-3">: {values.MaritalStatusId !== '' && dataSeed.maritalStatuses.find(el => el.id.toString() == values.MaritalStatusId).name}</td>
                    <td className="font-weight-bold col-3">Nama Pasangan</td>
                    <td className="col-3">: {values.SpouseName}</td>
                </tr>
                <tr className="d-flex">
                    <td className="font-weight-bold col-3">Pendidikan</td>
                    <td className="col-3">:  {values.EducationId !== '' && dataSeed.educations.find(el => el.id.toString() == values.EducationId).name}</td>
                    <td className="font-weight-bold col-3"></td>
                    <td className="col-3">: </td>
                </tr>
                <tr className="d-flex">
                    <td className="font-weight-bold col-3"></td>
                    <td className="col-3"></td>
                    <td className="font-weight-bold col-3"></td>
                    <td className="col-3"></td>
                </tr>
                <tr className="d-flex">
                    <td className="font-weight-bold col-3" >Alamat</td>
                    <td className="col-3" colSpan="3">: {values.Address1}</td>
                </tr>
                <tr className="d-flex">
                    <td className="font-weight-bold col-3" ></td>
                    <td className="col-3" colSpan="3">: {values.Address2}</td>
                </tr>
                <tr className="d-flex">
                    <td className="font-weight-bold col-3">Negara</td>
                    <td className="col-3">: {values.Country}</td>
                    <td className="font-weight-bold col-3">Provinsi {values.ProvinceId}</td>
                    <td className="col-3">: {props.provinces.map((item, key) => { if (item.Id == values.ProvinceId) { return item.Name; }})}</td>
                </tr>
                <tr className="d-flex">
                    <td className="font-weight-bold col-3">Kota</td>
                    <td className="col-3">: {props.cities.map((item, key) => { if (item.Id == values.CityId) { return item.Name; } })}</td>
                    <td className="font-weight-bold col-3">Kecamatan</td>
                    <td className="col-3">: {values.SubDistrict}</td>
                </tr>
                <tr className="d-flex">
                    <td className="font-weight-bold col-3">Kelurahan</td>
                    <td className="col-3">: {values.Village}</td>
                    <td className="font-weight-bold col-3">RT/RW</td>
                    <td className="col-3">: {values.RT}/{values.RW}</td>
                </tr>
                <tr className="d-flex">
                    <td className="font-weight-bold col-3">Kode Pos</td>
                    <td className="col-3">: {values.PostalCode}</td>
                    <td className="font-weight-bold col-3">Telp Rumah</td>
                    <td className="col-3">: {values.HomePhone}</td>
                </tr>
                <tr className="d-flex">
                    <td className="font-weight-bold col-3">No HP</td>
                    <td className="col-3">: {values.MobilePhone}</td>
                    <td className="font-weight-bold col-3">Email</td>
                    <td className="col-3">: {values.Email}</td>
                </tr>
                <tr className="d-flex">
                    <td className="font-weight-bold col-3"></td>
                    <td className="col-3"></td>
                    <td className="font-weight-bold col-3"></td>
                    <td className="col-3"></td>
                </tr>
                <tr className="d-flex">
                    <td className="font-weight-bold col-3">Nama Pemegang Rekening</td>
                    <td className="col-3">: {values.BankAccountHolderName2}</td>
                    <td className="font-weight-bold col-3">Nomor Rekening</td>
                    <td className="col-3">: {values.BankAccountNumber2}</td>
                </tr>
                <tr className="d-flex">
                    <td className="font-weight-bold col-3">Bank</td>
                    <td className="col-3">: {values.Bank}</td>
                    <td className="font-weight-bold col-3">Mata Uang</td>
                    <td className="col-3">: {values.BankAccountCurrency2}</td>
                </tr>
                <tr className="d-flex">
                    <td className="font-weight-bold col-3"></td>
                    <td className="col-3"></td>
                    <td className="font-weight-bold col-3"></td>
                    <td className="col-3"></td>
                </tr>
                <tr className="d-flex">
                    <td className="font-weight-bold col-3">Pekerjaan</td>
                    <td className="col-3">: {occupations.find(el => el.Id.toString() == values.OccupationId) ? occupations.find(el => el.Id.toString() == values.OccupationId).Description : ''}
                    </td>
                    <td className="font-weight-bold col-3">Pekerjaan Lainnya</td>
                    <td className="col-3">: {values.OccupationOthers}</td>
                </tr>
                <tr className="d-flex">
                    <td className="font-weight-bold col-3">Posisi</td>
                    <td className="col-3">: {props.positions.find(el => el.Id.toString() == values.PositionId)? props.positions.find(el => el.Id.toString() == values.PositionId).Description : ''}</td>
                    <td className="font-weight-bold col-3">Posisi Lainnya</td>
                    <td className="col-3">: {values.OccupationOthers}</td>
                </tr>
                <tr className="d-flex">
                    <td className="font-weight-bold col-3">Bidang Usaha</td>
                    <td className="col-3">: {props.businessFields.find(el => el.Id.toString() == values.BusinessFieldId) ?  props.businessFields.find(el => el.Id.toString() == values.BusinessFieldId).Description : ''}</td>
                    <td className="font-weight-bold col-3">Bidang Usaha Lainnya</td>
                    <td className="col-3">: {values.OccupationOthers}</td>
                </tr>
                <tr className="d-flex">
                    <td className="font-weight-bold col-3">Penghasilan / Tahun</td>
                    <td className="col-3">: {values.IncomePerAnnumId !== '' && dataSeed.incomePerAnnums.find(el => el.id.toString() == values.IncomePerAnnumId).name}</td>
                    <td className="font-weight-bold col-3">Nama Tempat Bekerja/Usaha/Sekolah</td>
                    <td className="col-3">: {values.CompanyName}</td>
                </tr>
                <tr className="d-flex">
                    <td className="font-weight-bold col-3">Sumber Penghasilan</td>
                    <td className="col-3">: {values.FundSourceId !== '' && dataSeed.fundSources.find(el => el.id.toString() == values.FundSourceId).name}</td>
                    <td className="font-weight-bold col-3">Sumber Penghasilan Lainnya</td>
                    <td className="col-3">: {values.FundSourceOthers}</td>
                </tr>
                <tr className="d-flex">
                    <td className="font-weight-bold col-3">Alamat Tempat Bekerja/Usaha/Sekolah</td>
                    <td className="col-9">: {values.CompanyAddress}</td>
                </tr>
                <tr className="d-flex">
                    <td className="font-weight-bold col-3">Kota</td>
                    <td className="col-3">: {values.CompanyAddressCity}</td>
                    <td className="font-weight-bold col-3">Kode Pos</td>
                    <td className="col-3">: {values.CompanyPostalCode}</td>
                </tr>
                <tr className="d-flex">
                    <td className="font-weight-bold col-3">No Telepon Tempat Bekerja/Usaha/Sekolah</td>
                    <td className="col-3">: {values.CompanyPhoneAreaCode} - {values.CompanyPhoneNumber}</td>
                    <td className="font-weight-bold col-3">Lama Bekerja / Usaha</td>
                    <td className="col-3">: {values.LengthOfWork} Tahun</td>
                </tr>
                <tr className="d-flex">
                    <td className="font-weight-bold col-3"></td>
                    <td className="col-3"></td>
                    <td className="font-weight-bold col-3"></td>
                    <td className="col-3"></td>
                </tr>
              
                <tr className="d-flex">
                    <td className="font-weight-bold col-3">Tujuan Investasi</td>
                    <td className="col-3">: {values.InvestmentObjectiveId !== '' && dataSeed.investmentObjectives.find(el => el.id.toString() == values.InvestmentObjectiveId).name}</td>
                    <td className="font-weight-bold col-3">Kepemilikan Asset</td>
                    <td className="col-3">: {values.AssetOwnerId !== '' && dataSeed.assetOwnerships.find(el => el.id.toString() == values.AssetOwnerId.toString()).name}</td>
                </tr>
                <tr className="d-flex">
                    <td className="font-weight-bold col-3">Penghasilan Per Tahun 2</td>
                    <td className="col-3">: {values.IncomePerAnnumBCA !== '' && dataSeed.incomePerAnnumBCAs.find(el => el.id.toString() == values.IncomePerAnnumBCA).name}</td>
                    <td className="font-weight-bold col-3">Wajib FATCA</td>
                    <td className="col-3">: {values.FATCAMandatory !== '' && dataSeed.fATCAs.find(el => el.id.toString() == values.FATCAMandatory).name}</td>
                </tr>
                <tr className="d-flex">
                    <td className="font-weight-bold col-3">TIN / SSN</td>
                    <td className="col-3">: {values.TINSSN}</td>
                    <td className="font-weight-bold col-3"></td>
                    <td className="col-3"></td>
                </tr>
            </tbody>
        </table>
        <Row>
            <Col md="4" xs="4">
                <Label className="font-weight-bold">Foto KTP</Label>
                <img className="img-fluid" src={values.PhotoKTP} alt="" />
            </Col>
            <Col md="4" xs="4">
                <Label className="font-weight-bold">Foto Selfie Pegang KTP</Label>
                <img className="img-fluid" src={values.PhotoSelfieKTP} alt="" />
            </Col>
            <Col md="4" xs="4">
                <Label className="font-weight-bold">Foto Tanda Tangan</Label>
                <img className="img-fluid" src={values.SignatureImage} alt="" />
            </Col>
        </Row>
        {/*<Row>*/}
        {/*    <Col md="2" sm="5" xs="12">*/}
        {/*        <FormGroup>*/}
        {/*            <Label>Kode Keamanan<span className="text-danger">*</span></Label><br />*/}
        {/*            <img src={state.imageValidation + '?' + state.imageHash} alt="" />*/}
        {/*            <Button onClick={() => reloadCaptcha()} type="button" outline color="info" size="sm">Reload Captcha</Button>*/}
        {/*            <Input tag={Field} name="ValidationCode" value={state.validationCode}  required="required" maxLength="4" bsSize="sm" />*/}
        {/*        </FormGroup>*/}
        {/*    </Col>*/}
        {/*    <Col md="5">*/}
        {/*    </Col>*/}
        {/*</Row>*/}
        <Row>
            <Col md="12">
                &nbsp;
            </Col>
        </Row>
    </React.Fragment>
)


// WEBPACK FOOTER //
// ./src/components/Page6Summary.js